import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { II18NRepo } from './II18NRepo';
import { UrlPath } from '../../services/UrlPath';

@Injectable()
export class I18NRepo extends II18NRepo {
	private static _userLang = 'en';
	private _deferred: Promise<any>;

	constructor(private http: HttpClient, private urlPath: UrlPath) {
		super();
	}

	public loadTokens(langLocale: string): Promise<any> {
		if (!this._deferred) {
			this._deferred = this._load(langLocale).finally(() => {
				this._deferred = null;
			});
		}
		return this._deferred;
	}

	private async _load(langLocale: string): Promise<any> {
		if (!langLocale) {
			langLocale = I18NRepo._userLang;
		}

		const pull = async (lang: string): Promise<any> => {
			const path = this.urlPath.getRootPath('assets/locales/:lang/tokens.json', { lang });
			const result: any = await firstValueFrom(this.http.get(path));
			if (result && result.tokens) {
				return result.tokens;
			}
			throw new Error('Invalid i18n file');
		};

		const short = langLocale.substring(0, 2);
		const candidates = [...new Set([langLocale, short.length < langLocale.length ? short : null, 'en-US'].filter(Boolean))];
		for (const lang of candidates) {
			try {
				return await pull(lang);
			} catch {
				// try next candidate
			}
		}
		throw new Error('Could not find internationalization tokens.');
	}
}
